<app-navbar *ngIf="this.authService.loggedIn" (openIframeEvent)="receiveIframeUrl($event)"></app-navbar>
<router-outlet />
<app-spinner></app-spinner>
<!-- <app-chatbot *ngIf="this.authService.loggedIn"></app-chatbot> -->

<!-- Fullscreen iframe overlay -->
<div *ngIf="showIframe" 
  style="position:fixed;top:0;left:0;width:100vw;height:100vh;
         background:white;z-index:9999;display:flex;flex-direction:column;">
  
  <!-- Header -->
  <div style="background:#323639;color:white;padding:10px 16px;
              display:flex;align-items:center;justify-content:space-between;">
    <span>Health Check</span>
    <button class="btn btn-sm btn-danger" (click)="closeIframe()">
      <i class="fa fa-times"></i> Close
    </button>
  </div>

  <!-- Iframe -->
  <iframe 
    [src]="safeIframeUrl" 
    style="flex:1;width:100%;border:none;"
    allow="fullscreen">
  </iframe>
</div>


<!-- <app-footer *ngIf="this.authService.loggedIn"></app-footer> -->